export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8665.adad2e80.jpg";